<header id="header" #header class="noselect">
  <nav role="navigation" *ngIf="isMobileDevice">
    <div id="menuToggle">
      <input type="checkbox" />
      <span></span>
      <span></span>
      <span></span>
      <ul id="menu">
        <li>
          <a href="#program" (click)="scrollAfterClick()">
            <div class="link">
              <h3>Características del programa</h3>
            </div>
          </a>
        </li>
        <li>
          <a href="#requirements" (click)="scrollAfterClick()">
            <div class="link">
              <h3>Requisitos</h3>
            </div>
          </a>
        </li>
        <li>
          <a href="{{ faqButtonPath }}">
            <div class="link last-button">
              <h3>FAQ´S</h3>
            </div>
          </a>
        </li>
      </ul>
    </div>
  </nav>
  <img class="img logo" [src]="currentLogoPath" alt="Fundacion Jala logo" />
  <div class="container" *ngIf="!isMobileDevice">
    <a href="{{ programButtonPath }}" (click)="scrollAfterClick()">
      <div class="link">
        <h3>Características del programa</h3>
      </div>
    </a>
    <a href="{{ requirementsButtonPath }}" (click)="scrollAfterClick()">
      <div class="link">
        <h3>Requisitos</h3>
      </div>
    </a>
    <a href="{{ faqButtonPath }}">
      <div class="link last-button">
        <h3>FAQ´S</h3>
      </div>
    </a>
  </div>
  <a href="javascript:void(0)" (click)="scrollToSkillSection()" class="register-button">
    <img  class="redirect" [src]="registerButtonPath" alt="Register button" />
    <span class="redirect">Inscribirme</span>
  </a>
</header>
